import { FREE_PLAN, fetchVipPlans } from './vipSkuApi'

const LEGACY_SESSION_KEY = 'plus_vip_plans_cache_v1'

/** @type {{ plans: object[], hasYearly: boolean, cachedAt: number } | null} */
let memory = null
/** @type {Promise<{ plans: object[], hasYearly: boolean, cachedAt: number }> | null} */
let inflight = null

if (typeof sessionStorage !== 'undefined') {
  try {
    sessionStorage.removeItem(LEGACY_SESSION_KEY)
  } catch {
    /* ignore */
  }
}

function normalizePayload({ plans, hasYearly }) {
  return {
    plans: plans && plans.length ? plans : [FREE_PLAN],
    hasYearly: !!hasYearly,
    cachedAt: Date.now()
  }
}

function fetchAndCache() {
  if (inflight) return inflight

  inflight = fetchVipPlans()
    .then(result => {
      const payload = normalizePayload(result)
      memory = payload
      return payload
    })
    .finally(() => {
      inflight = null
    })

  return inflight
}

/** 读取内存中的套餐快照（仅用于首屏占位，不保证最新） */
export function getVipPlansCacheSnapshot() {
  return memory
}

/** 无缓存时预取；有缓存则直接返回（不请求网络） */
export function prefetchVipPlans(opts = {}) {
  if (opts.force === true) return fetchAndCache()
  if (memory) return Promise.resolve(memory)
  return fetchAndCache()
}

/** 始终请求最新套餐并更新缓存 */
export function refreshVipPlans() {
  return fetchAndCache()
}

/**
 * 进入定价页：有缓存则先展示，同时后台刷新；无缓存则等待首次请求
 * @param {(payload: object) => void} [onUpdated]
 */
export function warmVipPlansForPricing(onUpdated) {
  const cached = memory
  const refresh = refreshVipPlans()
    .then(payload => {
      if (typeof onUpdated === 'function') onUpdated(payload)
      return payload
    })
    .catch(err => {
      if (cached) return cached
      throw err
    })

  if (cached) {
    refresh.catch(() => {})
    return Promise.resolve(cached)
  }
  return refresh
}

export function invalidateVipPlansCache() {
  memory = null
}
